import React from 'react'
import { twMerge } from 'tailwind-merge'

export const Card = ({ className, children }) => {
    const classes = twMerge("p-4 m-8 border rounded-md shadow-md border-torbu-gray", className)
    return <div className={classes}>{children}</div>
}
